<div class="flex flex-col h-full flex-1 min-h-0">

  <p-table [scrollable]="true" [size]="'small'" [value]="outgoingInvoices()" scrollHeight="flex">
    <ng-template #header>
      <tr>
        <th *dev pResizableColumn pSortableColumn="number">Uuid
        </th>
        <th pResizableColumn pSortableColumn="number">{{ 'invoice.number' | translate }}
          <p-sortIcon field="number"/>
        </th>
        <th pResizableColumn pSortableColumn="date">{{ 'invoice.invoice-date' | translate }}
          <p-sortIcon field="date"/>
        </th>
        <th pResizableColumn>{{ 'invoice.recipient' | translate }}</th>
        <th pResizableColumn pSortableColumn="format">{{ 'invoice.format' | translate }}
          <p-sortIcon field="format"/>
        </th>
        <th pResizableColumn>{{ 'invoice.downloaded' | translate }}</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-invoice>
      <tr>
        <td *dev>{{ invoice.uuid }}</td>
        <td>{{ invoice.number }}</td>
        <td>{{ invoice.date | date : 'dd/MM/yyyy' }}</td>
        <td>{{ invoice.recipient?.name }}</td>
        <td>{{ invoice.format }}</td>
        <td>{{ invoice.downloaded ? ('common.yes' | translate) : ('common.no' | translate) }}</td>
        <td class="flex justify-end gap-1">
          <elcia-button (onClick)="downloadInvoicePeppol(invoice)" [icon]="'download'" [variant]="'text'"/>
          <elcia-button (onClick)="downloadAttachments(invoice)" [icon]="'attachment'" [variant]="'text'"/>
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>
